import createGetFormSubmitErrors from '../selectors/getFormSubmitErrors';
import immutable from '../structure/immutable';

export default createGetFormSubmitErrors(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormSubmitErrors.js
// module id = 1199
// module chunks = 0